import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  DELIVERY_LIST: 'carriage-delivery'
}

const routes = [
  {
    path: 'delivery/',
    name: ROUTES.DELIVERY_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['carriage_delivery_list'],
      requiresAuth: true
    },
    component: () => import('./DeliveryList.vue')
  }

]

export { routes, ROUTES }
